export default __webpack_public_path__ + "static/media/sec-banner.b74ecceb.png";